import axios from 'src/libs/axios';
import { QueryFunctionContext } from '@tanstack/react-query';

const getInternalPIC = (args: QueryFunctionContext<any>) => {
  const [url, params] = args.queryKey;

  return axios({
    method: 'get',
    url,
    params,
  });
};

const getInternalPICList = (args: QueryFunctionContext<any>) => {
  const [url, params] = args.queryKey;

  return axios({
    method: 'get',
    url,
    params,
  });
};

const updateInternalPIC = (url, data: Payload.InternalPIC) => {
  return axios({
    method: 'put',
    url,
    data,
  });
};

export default { getInternalPIC, getInternalPICList, updateInternalPIC };
